exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// /mnt/e/apps/architect3/client/node_modules/core-js/modules/_object-pie.js
// module id = 9e9+
// module chunks = polyfills